import { Table, TableBody } from '@mui/material'
import DenomRow from '../../../components/DenomRow'
import LoadingWrapper from '../../../components/LoadingWraper'
import { SectionWrapper } from '../../../components/tableComponents'
import { TOmnistarAccountResponse, TSpendLimit } from '../../../types/cosmosApi'


type props = {
    account : TOmnistarAccountResponse | undefined,
    isLoading: boolean, 
    error: unknown | undefined,
    isSuccess: boolean,
}

const Allowances = ({account, isLoading = false, error, isSuccess}: props) => {
    return (
        <div>
            <h4>Allowance: </h4>
            <LoadingWrapper
                child={
                    <SectionWrapper>
                        <Table  aria-label="allowances table">
                            <TableBody>
                                { account?.allowances.map((a: any) => (
                                                a.allowance.spend_limit.map((sl: TSpendLimit, j: number) => {
                                                    return <DenomRow key={sl.denom+sl.amount} denom={sl.denom} amount={sl.amount} />
                                                }
                                            )
                                        )
                                    )
                                }
                            </TableBody>
                        </Table>
                    </SectionWrapper>
                }
                isLoading = {isLoading }
                error = {!!error}
                isSucceeded={isSuccess}
                errorTxt = {`Could not found any allowances`}
            />
        </div>
    );
}

export default Allowances